import { Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";
import ByzMuiMultiSelect, {
  SelectOption,
} from "src/components/core-components/mui/ByzMuiMultiSelect";
import { useMemo, useState } from "react";
import ByzMuiSearchFilterButton from "src/components/core-components/mui/buttons/ByzMuiSearchFilterButton";
import ByzMuiPrintButton from "src/components/core-components/mui/buttons/ByzMuiPrintButton";
import { useAppSelector } from "src/app/hooks";
import DietRequestRefectroyDataGrid from "./refectory-data-grid";
import ByzCard from "src/components/core-components/ByzCard";

//CKAPISIZ;452953;05052025
interface BranchOption {
  value: number;
  label: string;
}

function DietRequestsRefectory() {
  const [filterStartDate, setFilterStartDate] = useState<Date | null>(
    new Date()
  );
  const [filterEndDate, setFilterEndDate] = useState<Date | null>(new Date());
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const authState = useAppSelector((state) => state.auth);
  const { t } = useTranslate();

  const handleSearch = () => {
    setGridRefreshKey((k) => k + 1);
  };

  const branchOptions: BranchOption[] = useMemo(
    () =>
      authState.user?.UserAssPriviliges?.filter(
        (item: any) => item.ID != null
      ).map((item: any) => ({
        value: item.ID!,
        label: `${item.OFFICE_NAME} ${item.OFF_ID}`,
      })) || [],
    [authState.user]
  );

  const [selectedBranch, setSelectedBranch] = useState<BranchOption | null>(
    () => branchOptions[0] ?? null
  );

  const statusOptions: SelectOption[] = [
    { label: t("diet-requests-refectory.pending"), value: "beklemede" },
    { label: t("diet-requests-refectory.sent"), value: "gonderildi" },
    { label: t("diet-requests-refectory.approved"), value: "onaylandi" },
    { label: t("diet-requests-refectory.rejected"), value: "reddedildi" },
    { label: t("diet-requests-refectory.completed"), value: "tamamlandi" },
  ];

  const [selectedStatus, setSelectedStatus] = useState<SelectOption[]>(
    statusOptions.filter((opt) => opt.value === "gonderildi")
  );

  const handleListSelectedStatus = async (selected: SelectOption[]) => {
    setSelectedStatus(selected);
    try {
      console.log(
        "listSelectedStatus API cevabı: Duruma Göre Listelendi",
        selected
      );
    } catch (error) {
      console.error("Durum bazlı listeleme hatası:", error);
    }
  };
  return (
    <>
      <ByzCard title={t("diet-requests-refectory.filter")}>
        <Grid container md={12} xs={12} spacing={2} sx={{ pl: 1.5, pt: 2.5 }}>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              options={branchOptions}
              label="label"
              placeholder={t("diet-requests-refectory.branch-selection")}
              sx={{ width: "100%" }}
              multiple={false}
              value={selectedBranch}
              onChange={(_, newValue) => {
                setSelectedBranch(newValue as BranchOption | null);
              }}
              renderInput={(params) => <ByzMuiTextField {...params} />}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiDatePicker
              label={t("start-date")}
              sx={{ width: "100%" }}
              value={filterStartDate}
              onChange={(newValue) => {
                setFilterStartDate(newValue);
              }}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiDatePicker
              label={t("end-date")}
              sx={{ width: "100%" }}
              value={filterEndDate}
              onChange={(newValue) => {
                setFilterEndDate(newValue);
              }}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiMultiSelect
              label={t("diet-requests-refectory.status")}
              options={statusOptions}
              value={selectedStatus}
              onChange={handleListSelectedStatus}
              minWidth={null}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("diet-requests-refectory.admission")}
              placeholder={t("diet-requests-refectory.admission")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("diet-requests-refectory.building")}
              placeholder={t("diet-requests-refectory.building")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          md={12}
          xs={12}
          spacing={2}
          sx={{
            pl: 1.5,
            pt: 1.5,
            pb: 2.5,
          }}
        >
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("diet-requests-refectory.floors")}
              placeholder={t("diet-requests-refectory.floors")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("department")}
              placeholder={t("department")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("meal")}
              placeholder={t("meal")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
          <Grid md={2} xs={12}>
            <ByzMuiSelect
              renderInput={(params) => <ByzMuiTextField {...params} />}
              label={t("diet")}
              placeholder={t("diet")}
              sx={{ width: "100%" }}
              options={[]}
            />
          </Grid>
          <Grid
            container
            md={4}
            xs={12}
            alignItems="right"
            justifyContent={"center"}
          >
            <ByzMuiSearchFilterButton onClick={handleSearch} />
            <Divider
              orientation="vertical"
              sx={{
                borderColor: "#E0E0E0",
                borderRightWidth: "2px",
                mx: 2,
              }}
            />
            <ByzMuiPrintButton type={1} />
            <ByzMuiPrintButton type={2} />
            <ByzMuiPrintButton type={3} />
          </Grid>
        </Grid>
      </ByzCard>

      <ByzCard title={t("diet-requests-refectory.patient-list")}>
        <DietRequestRefectroyDataGrid
          filterStartDate={filterStartDate}
          filterEndDate={filterEndDate}
          gridRefreshKey={gridRefreshKey}
        />
      </ByzCard>
    </>
  );
}

export default DietRequestsRefectory;
